<i class="b-radius-max"
   [ngClass]="['flag-' + siteId.replace('_trade', '') | lowercase, simpleMultisite ? 'flag-dim-simple' : 'flag-dim', dropDownFlag ? 'drop-down-flag' : 'flag-dim']"
   aria-hidden="true"></i>